import { ProductPage } from '@api/types';
import { ContentArea, ProductDetails } from '@components';

export type ProductPageContentProps = {
  page?: ProductPage;
};

export const ProductPageContent = ({ page = {} }: ProductPageContentProps) => {
  const { content, requestInfoEnabled, requestOrderEnabled } = page;
  return (
    <>
      <ProductDetails
        product={page}
        requestInfoEnabled={requestInfoEnabled}
        requestOrderEnabled={requestOrderEnabled}
      />
      <ContentArea content={content} enableNativeOverlay />
    </>
  );
};
